import { ExtensionConfig } from '@goto/shell'
import { getLaunchDarklyFlag } from '../helpers/shell-helpers'
import { LaunchDarklyVariations } from '../models/feature-flag.models'

const extensionConfig: ExtensionConfig = {
  id: '@ucc-messaging/messaging-extension',
  get url() {
    const inboxVersion = getLaunchDarklyFlag(LaunchDarklyVariations.INBOX_VERSION)
    return new URL(
      inboxVersion
        ? `/experiences/messaging/${inboxVersion}/messaging-extension.mjs`
        : `/experiences/messaging/messaging-extension.js`,
      location.origin,
    )
  },
  prerequisites: {
    roles: 'jive || gotoconnect || g2m',
  },
  esModule: true,
}

export default extensionConfig
